import { Phone, MessageSquare, FileText } from "lucide-react";
import { BRAND } from "@/data/content";

export default function FloatingCTA() {
  return (
    <div
      data-testid="floating-cta"
      className="fixed bottom-20 left-1/2 -translate-x-1/2 z-40 md:hidden"
    >
      <div className="flex items-center gap-2 bg-[#111111]/95 backdrop-blur-xl border border-white/10 px-2 py-2 rounded-full shadow-2xl">
        <a
          href={`tel:${BRAND.phoneRaw}`}
          data-testid="floating-call"
          aria-label="Call"
          className="w-11 h-11 rounded-full bg-[#C8A44D] text-[#111] flex items-center justify-center"
        >
          <Phone size={17} strokeWidth={1.75} />
        </a>
        <a
          href={`sms:${BRAND.phoneRaw}`}
          data-testid="floating-text"
          aria-label="Text"
          className="w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center"
        >
          <MessageSquare size={17} strokeWidth={1.75} />
        </a>
        <a
          href="#estimate"
          data-testid="floating-estimate"
          className="inline-flex items-center gap-2 bg-white text-[#111] px-5 py-3 rounded-full text-sm font-medium"
        >
          <FileText size={14} strokeWidth={1.75} />
          Estimate
        </a>
      </div>
    </div>
  );
}
